module.exports = {"430473400":"松木工业园"}


//////////////////
// WEBPACK FOOTER
// ./src/town/430473.json
// module id = 1845
// module chunks = 0